module.exports = __webpack_public_path__ + "static/media/moderator-icon.8d36d3a7.svg";